import React from 'react';
import { Shield } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';

const ReputationScoreCard = ({ score, health }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return '#10B981'; // green
    if (score >= 65) return '#00B4D8'; // cyan
    if (score >= 50) return '#F59E0B'; // orange
    if (score >= 30) return '#EF4444'; // red
    return '#DC2626'; // dark red
  };

  const getHealthBadgeColor = (health) => {
    switch (health) {
      case 'Excellent':
        return 'bg-green-100 text-green-800';
      case 'Good':
        return 'bg-cyan-100 text-[#00B4D8]';
      case 'Fair':
        return 'bg-orange-100 text-orange-800';
      case 'Poor':
        return 'bg-red-100 text-red-800';
      case 'Critical':
        return 'bg-red-200 text-red-900';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const scoreColor = getScoreColor(score);
  const circumference = 2 * Math.PI * 90; // radius = 90
  const dashoffset = circumference - (score / 100) * circumference;

  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardContent className="pt-6">
        <div className="flex flex-col items-center">
          {/* Gauge Chart */}
          <div className="relative w-64 h-64 mb-4">
            <svg className="transform -rotate-90" width="256" height="256" viewBox="0 0 256 256">
              {/* Background circle */}
              <circle
                cx="128"
                cy="128"
                r="90"
                fill="none"
                stroke="#E5E7EB"
                strokeWidth="20"
              />
              {/* Progress circle */}
              <circle
                cx="128"
                cy="128"
                r="90"
                fill="none"
                stroke={scoreColor}
                strokeWidth="20"
                strokeDasharray={circumference}
                strokeDashoffset={dashoffset}
                strokeLinecap="round"
                style={{ transition: 'stroke-dashoffset 1s ease-in-out' }}
              />
            </svg>
            
            {/* Score in center */}
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div 
                className="text-6xl font-bold mb-2" 
                style={{ color: scoreColor }}
              >
                {score !== null && score !== undefined ? Math.round(score) : '-'}
              </div>
              <div className="text-sm text-[#6C757D]">Reputation Score</div>
            </div>
          </div>

          {/* Health Badge */}
          <div className={`px-6 py-2 rounded-full font-semibold text-lg ${getHealthBadgeColor(health)}`}>
            <div className="flex items-center space-x-2">
              <Shield className="h-5 w-5" />
              <span>{health || 'Unknown'}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReputationScoreCard;
